'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var mafmt = require('mafmt');

var multiaddr = require('multiaddr');

var CircuitDialer = require('./circuit/dialer');

var utilsFactory = require('./circuit/utils');

var debug = require('debug');

var log = debug('libp2p:circuit:transportdialer');
log.err = debug('libp2p:circuit:error:transportdialer');

var _createListener = require('./listener');

var Circuit =
/*#__PURE__*/
function () {
  _createClass(Circuit, null, [{
    key: "tag",
    get: function get() {
      return 'Circuit';
    }
    /**
     * Creates an instance of Dialer.
     *
     * @param {Swarm} swarm - the swarm
     * @param {any} options - config options
     *
     * @memberOf Dialer
     */

  }]);

  function Circuit(swarm, options) {
    var _this = this;

    _classCallCheck(this, Circuit);

    this.options = options || {};
    this.swarm = swarm;
    this.dialer = null;
    this.utils = utilsFactory(swarm);
    this.peerInfo = this.swarm._peerInfo;
    this.relays = this.filter(this.peerInfo.multiaddrs.toArray()); // if no explicit relays, add a default relay addr

    if (this.relays.length === 0) {
      this.peerInfo.multiaddrs.add("/p2p-circuit/ipfs/".concat(this.peerInfo.id.toB58String()));
    }

    this.dialer = new CircuitDialer(swarm, options);
    this.swarm.on('peer-mux-established', this.dialer.canHop.bind(this.dialer));
    this.swarm.on('peer-mux-closed', function (peerInfo) {
      _this.dialer.relayPeers.delete(peerInfo.id.toB58String());
    });
  }
  /**
   * Dial the relays in the Addresses.Swarm config
   *
   * @param {Array} relays
   * @return {void}
   */


  _createClass(Circuit, [{
    key: "_dialSwarmRelays",
    value: function _dialSwarmRelays() {
      var _this2 = this;

      // if we have relay addresses in swarm config, then dial those relays
      this.relays.forEach(function (relay) {
        var relaySegments = relay.toString().split('/p2p-circuit').filter(function (segment) {
          return segment.length;
        });
        relaySegments.forEach(function (relaySegment) {
          var ma = _this2.utils.peerInfoFromMa(multiaddr(relaySegment));

          _this2.dialer._dialRelay(ma);
        });
      });
    }
    /**
     * Dial a peer over a relay
     *
     * @param {multiaddr} ma - the multiaddr of the peer to dial
     * @param {Object} options - dial options
     * @param {Function} cb - a callback called once dialed
     * @returns {Connection} - the connection
     *
     * @memberOf Dialer
     */

  }, {
    key: "dial",
    value: function dial(ma, options, cb) {
      return this.dialer.dial(ma, options, cb);
    }
    /**
     * Create a listener
     *
     * @param {any} options
     * @param {Function} handler
     * @return {listener}
     */

  }, {
    key: "createListener",
    value: function createListener(options, handler) {
      if (typeof options === 'function') {
        handler = options;
        options = this.options || {};
      }

      var listener = _createListener(this.swarm, options, handler);

      listener.on('listen', this._dialSwarmRelays.bind(this));
      return listener;
    }
    /**
     * Filter check for all multiaddresses
     * that this transport can dial on
     *
     * @param {any} multiaddrs
     * @returns {Array<multiaddr>}
     *
     * @memberOf Dialer
     */

  }, {
    key: "filter",
    value: function filter(multiaddrs) {
      if (!Array.isArray(multiaddrs)) {
        multiaddrs = [multiaddrs];
      }

      return multiaddrs.filter(function (ma) {
        return mafmt.Circuit.matches(ma);
      });
    }
  }]);

  return Circuit;
}();

module.exports = Circuit;